import React, { Component } from 'react'
import Toast from 'react-bootstrap/Toast';

class ToasterComponent extends Component{
    constructor(props){
        super(props);
        console.log("props",this.props)
        this.state = {
            message : this.props.message,
            show : this.props.show
        }
    }


    componentWillReceiveProps(nextProps) {
        console.log("nextProps",nextProps)
      // You don't have to do this check first, but it can help prevent an unneeded render
      if (nextProps.show !== this.state.show) {
            this.setState({ 
                show: nextProps.show, 
                message: nextProps.message
            },() =>{
                setTimeout(() => {
                    this.setState({show:false})
                }, 3000);
            });
      }


    }

    render(){
        return(
            <div>
                    {this.state.show ? <div className="snackbar show">{this.state.message}</div> : ''}
            </div>
        );
    }
}

export default ToasterComponent;